var map = {
	"./book.svg": 196,
	"./doctor1.png": 1,
	"./exercise.svg": 445,
	"./features.svg": 90,
	"./healthcare.svg": 966,
	"./instant.svg": 522,
	"./logo.svg": 914,
	"./meal.svg": 674,
	"./self.svg": 609,
	"./sleep.svg": 572,
	"./tips.svg": 77,
	"./water.svg": 380
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;